import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';

import { ConfirmacaoDaAcao, ResultadoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
}

export default function ModalAccept(props: Props) {
  const modalID = 'validation-accept';

  const { openModal, closeModal } = useModal();
  const { callback, id } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);

  function handleClose() {
    closeModal();
    if (!!success) callback({ id: 'open_feedback' });
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setSuccess(false);
      setIsOpen(true);
    } else if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}-finish`) {
      setSuccess(true);
      setIsOpen(true);
    } else {
      setSuccess(false);
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  if (success) {
    return (
      <ResultadoDaAcao title="Mandou bem!" onClose={handleClose}>
        Sua validação foi realizada com sucesso.
      </ResultadoDaAcao>
    );
  }

  return (
    <ConfirmacaoDaAcao
      title="Validar Realização Destaque"
      onClose={handleClose}
      onConfirm={() => {
        callback({ id: 'accept' });
        closeModal();
      }}
    >
      <p className="m-0">Você pode validar a entrega se ela estiver cadastrada de forma adequada. Deseja confirmar essa ação?</p>
    </ConfirmacaoDaAcao>
  );
}
